import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpConfigOptions, HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class WebServiceProvider {
  private readonly httpService = inject(HttpService);

  public get<T>(options: HttpConfigOptions): Promise<T> {
    return firstValueFrom(this.httpService.get<T>(options));
  }

  public post<T>(options: HttpConfigOptions): Promise<T> {
    return firstValueFrom(this.httpService.post<T>(options));
  }

  public put<T>(options: HttpConfigOptions): Promise<T> {
    return firstValueFrom(this.httpService.put<T>(options));
  }

  public patch<T>(options: HttpConfigOptions): Promise<T> {
    return firstValueFrom(this.httpService.patch<T>(options));
  }

  public delete<T>(options: HttpConfigOptions): Promise<T> {
    return firstValueFrom(this.httpService.delete<T>(options));
  }
}
